import { useQuery } from "@tanstack/react-query";
import { getMotion } from "../services/viewingMotionsServices";
import { FIVE_MINUTES_IN_MS } from "../configuration/globalConstants";
import { useParams } from "react-router-dom";

export function useMotion(customId){
    const { motionId } = useParams()
    const id = customId ?? motionId

    return useQuery({
        queryKey: ['motions', { id }],
        queryFn: () => getMotion(id),
        staleTime: FIVE_MINUTES_IN_MS,
        enabled: !!id,
    })
}